/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface ConversationPatch {
  title?: string | null;
  meeting_type?: string | null;
  legal_hold_until?: string | null;
  clear_legal_hold?: boolean;
  match_not_needed?: boolean | null;
}
